import '../../style/store/store product/SP_Poster.css';
import icon1 from '../../../assets/store/stickynote.png';
import icon2 from '../../../assets/store/frame.png';


const SP_Poster =({img,title})=>{
  return(
    <div className="sp-poster">
      <img className="sp-poster-bg-img" src={img} alt="product-img"/>
      <div className="sp-poster-cover"></div>
      <div className="sp-poster-title-box">
        <img src={icon1} alt="icon"/>
        <div className="sp-p-t-b-title">{title}</div>
      </div>
      <img className="sp-poster-save-icon" src={icon2} alt="save-icon"/>
    </div>
  )
}

export default SP_Poster;